/**
 * Widget de soporte Wembii (reemplazo progresivo de Crisp).
 * En Create React App solo las variables con prefijo REACT_APP_ llegan al bundle.
 * Equivalente solicitado en .env: CHAT_WEMBII_ACTIVE → usar REACT_APP_CHAT_WEMBII_ACTIVE=true
 */

import { isEnvTruthy } from "../../../cores/config/featureFlags";

/**
 * En **production** solo se muestra si el env es explícitamente truthy.
 * En **development**, si la variable no llega al bundle (undefined) o queda vacía,
 * el widget queda **visible por defecto** para no bloquear el trabajo local; para ocultar:
 * `REACT_APP_CHAT_WEMBII_ACTIVE=false`
 */
export const isWembiiSupportChatActive = (): boolean => {
  const raw = process.env.REACT_APP_CHAT_WEMBII_ACTIVE;
  if (isEnvTruthy(raw)) return true;
  if (typeof raw === "string" && raw.trim() !== "" && !isEnvTruthy(raw)) {
    return false;
  }
  return process.env.NODE_ENV !== "production";
};

/** Tono alternativo (p. ej. violeta vs azul Crisp) para comparar durante el desarrollo. */
export const isWembiiSupportChatDevAccent = (): boolean =>
  isEnvTruthy(process.env.REACT_APP_CHAT_WEMBII_DEV_ACCENT);
